import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import { FilteringGuide } from "../models/filteringGuide";
import { StandardService } from "../services/standard.service";
import {
  FilteringEnum,
  CategoryEnum,
  StandardListType,
  UserRoleUserOperation,
  StandardTypeEnum,
  AddendumStatusEnum,
  UserRoleEnum,
  Constant,
} from "../core/constant";
import { Standard } from "../models/standard";
import { StandardList } from "../models/standard-list";
import { MatMenuTrigger } from "@angular/material/menu";
import { Router, ActivatedRoute } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CryptographyService } from "../services/cryptography.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { EquipmentStandard } from "../models/equipment-standard";
import { EquipmentStandardService } from "../services/equipment -standard.service";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { NrbesSet } from "../models/nrbesSet";
import { Country } from "../models/country";
import { NrbesItem } from "../models/nrbesItem";
import { Category } from "../models/category";
import { LocationType } from "../models/location-type";
import { AddendumService } from "../services/addendum.service";
import { DeleteDialogComponent } from "../delete-dialog/delete-dialog.component";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { FilterList } from "../models/filterList";
import { Sort } from "@angular/material/sort";

@Component({
  selector: "app-view-all-national-equipment-standard-list",
  templateUrl: "./view-all-national-equipment-standard-list.component.html",
  styleUrls: ["./view-all-national-equipment-standard-list.component.scss"],
})
export class ViewAllNationalEquipmentStandardListComponent implements OnInit {
  selectedCountryId: number = 0;
  nrbesItems: any;
  userRole: number;
  userId: number;
  page: number = 1;
  nrbesSet: NrbesSet;
  equipmentItems: NrbesItem[] = [];
  countries: Country[] = [];
  pageSize: number = 10;
  collectionSize: number = 0;
  isDeleted: boolean = false;
  loading: boolean = false;
  searchKey: string = "";
  standards: Standard[] = [];
  categoryList: Category[] = [];
  locationTypeList: LocationType[] = [];
  filterList: FilteringGuide[] = [];
  pageSizes: any[] = Constant.PageSizes;
  @ViewChild(MatMenuTrigger, { static: false }) trigger: MatMenuTrigger;
  equipmentStandard: EquipmentStandard = new EquipmentStandard();
  modalOption: NgbModalOptions = {};
  canEditNationalEquipmentStandard: boolean;
  canDeleteNationalEquipmentStandard: boolean;
  canRemoveEquipmentStandard: boolean;
  isDownloading: any = false;
  get standardListType() {
    return StandardListType;
  }
  get standardTypeEnum() {
    return StandardTypeEnum;
  }
  get addendumStatusEnum() {
    return AddendumStatusEnum;
  }
  get userRoleEnum() {
    return UserRoleEnum;
  }
  standardFiltrationForChipSet: FilterList = new FilterList();

  constructor(
    private standardService: StandardService,
    private equipmentStandardService: EquipmentStandardService,
    private addendumService: AddendumService,
    private router: Router,
    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,
    private cryptographyService: CryptographyService,
    private activatedRoute: ActivatedRoute,
    private ngbModal: NgbModal
  ) {}

  ngOnInit() {
    this.standardFiltrationForChipSet.standardListType =
      StandardListType.NationalEquipment;
    this.filterList =
      this.standardService.nationalEquipmentStandardFiltration.filterSet;
    this.pageSize =
      this.standardService.nationalEquipmentStandardFiltration.pageSize;
    this.searchKey =
      this.standardService.nationalEquipmentStandardFiltration.searchKey;
    this.storage.set("equipmentfilterSet", JSON.stringify(this.filterList));
    this.userId = this.cryptographyService.decryptData(
      this.storage.get("userId")
    );
    this.setUserPrivilages();
    this.userRole = this.cryptographyService.decryptData(
      this.storage.get("userRole")
    );
    this.getMasterDataForNrbes().subscribe(() => {
      let selectedCountries =
        this.userRole == this.userRoleEnum.MarketAdmin ||
        this.userRole == this.userRoleEnum.BasicUser
          ? this.cryptographyService.decryptData(this.storage.get("countryId"))
          : this.standardService.nationalEquipmentStandardFiltration.countryId
          ? this.standardService.nationalEquipmentStandardFiltration.countryId
          : this.countries != null
          ? this.countries[0].id
          : this.cryptographyService.decryptData(this.storage.get("countryId"));
      if (typeof selectedCountries == "object") {
        this.selectedCountryId = selectedCountries[0];
      } else if (
        typeof selectedCountries == "string" ||
        typeof this.selectedCountryId == "number"
      ) {
        this.selectedCountryId = selectedCountries;
      }
      this.storage.set(
        "selectedCountryId",
        this.cryptographyService.encryptData(this.selectedCountryId)
      );
      this.getAllNrbesBySelectedCountryId();
    });
  }

  compare(
    a: number | string | Date,
    b: number | string | Date,
    isAsc: boolean
  ) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortData(sort: Sort) {
    if (
      !sort.active ||
      sort.direction === "" ||
      !(this.nrbesItems.length > 0)
    ) {
      return;
    }

    const isAsc = sort.direction === "asc";
    this.nrbesItems.sort((a, b) => {
      switch (sort.active) {
        case "type":
          return this.compare(
            a.standard.equipmentStandard.equipmentType.name,
            b.standard.equipmentStandard.equipmentType.name,
            isAsc
          );
        case "supplier":
          return this.compare(
            a.standard.equipmentStandard.supplier.name,
            b.standard.equipmentStandard.supplier.name,
            isAsc
          );
        case "title":
          return this.compare(a.standard.title, b.standard.title, isAsc);
        case "model":
          return this.compare(
            a.standard.equipmentStandard.model,
            b.standard.equipmentStandard.model,
            isAsc
          );
        case "class":
          return this.compare(
            a.standard.equipmentStandard.equipmentClassType.name,
            b.standard.equipmentStandard.equipmentClassType.name,
            isAsc
          );
      }
    });
  }
  receivedFilteration($event) {
    this.page = 1;
    this.filterList = $event;
    this.standardService.nationalEquipmentStandardFiltration.filterSet =
      this.filterList;
    this.getAllNrbesBySelectedCountryId();
  }

  selectedItemsPerPageChange(event) {
    this.page = 1;
    this.pageSize = event.value;
    this.standardService.nationalEquipmentStandardFiltration.pageSize =
      event.value;
    this.getAllNrbesBySelectedCountryId();
  }

  getMasterDataForNrbes(): Observable<any> {
    this.loading = true;
    return new Observable<any>((observer) => {
      this.standardService
        .GetMasterDataForAddNrbes(
          this.cryptographyService.decryptData(this.storage.get("userRole")),
          this.cryptographyService.decryptData(this.storage.get("userId"))
        )
        .subscribe((data: any) => {
          this.countries = data.countries;
          if (
            this.cryptographyService.decryptData(
              this.storage.get("userRole")
            ) == this.userRoleEnum.MarketAdmin ||
            this.cryptographyService.decryptData(
              this.storage.get("userRole")
            ) == this.userRoleEnum.BasicUser
          ) {
            this.countries = this.countries.filter((x) =>
              this.cryptographyService
                .decryptData(this.storage.get("countryId"))
                .includes(x.id)
            );
          }
          this.categoryList = data.categories;
          this.locationTypeList = data.locationTypes;
          this.loading = false;
          observer.next();
        });
    });
  }

  selectCountry(event) {
    this.page = 1;
    this.selectedCountryId = event.value;
    this.standardService.nationalEquipmentStandardFiltration.countryId =
      event.value;
    this.storage.set(
      "selectedCountryId",
      this.cryptographyService.encryptData(this.selectedCountryId)
    );
    this.getAllNrbesBySelectedCountryId();
  }

  getAllNrbesBySelectedCountryId() {
    this.loading = true;
    this.standardService
      .getNrbesByCountryId(
        this.userId,
        [this.selectedCountryId],
        (this.page - 1) * this.pageSize,
        this.pageSize,
        this.filterList,
        this.standardService.nationalEquipmentStandardFiltration.searchKey,
        true
      )
      .subscribe((data: NrbesSet) => {
        //this.equipmentItems = [];
        this.nrbesSet = data;
        this.nrbesItems = this.nrbesSet.nrbes;
        console.log("NRb Set", this.nrbesItems);
        this.equipmentItems = data.nrbes; //.map(obj => new NrbesItem(obj));
        this.collectionSize = data.count;
        this.loading = false;
      });
  }

  setUserPrivilages() {
    if (!environment.skipAuthentication) {
      let userRoleUserOperation = this.storage.get("userRoleUserOperation")
        ? this.cryptographyService.decryptData(
            this.storage.get("userRoleUserOperation")
          )
        : this.storage.get("userRoleUserOperation");
      if (userRoleUserOperation) {
        this.canEditNationalEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanEditNationalEquipmentStandard
          ) !== -1;
        this.canDeleteNationalEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanDeleteNationalEquipmentStandard
          ) !== -1;
        this.canRemoveEquipmentStandard =
          userRoleUserOperation.indexOf(
            UserRoleUserOperation.CanRemoveEquipmentStandard
          ) !== -1;
      }
    } else {
      this.canEditNationalEquipmentStandard = true;
      this.canDeleteNationalEquipmentStandard = true;
      this.canRemoveEquipmentStandard = true;
    }
  }
  openDeletePopup(item, event) {
    event.stopPropagation();
    this.modalOption.backdrop = "static";
    this.modalOption.keyboard = false;
    this.equipmentStandard.id = item.standard.equipmentStandard.id;
    const modalRef = this.ngbModal.open(
      DeleteDialogComponent,
      this.modalOption
    );
    modalRef.componentInstance.title =
      "Do you want to remove this standard from the list? ";
    modalRef.componentInstance.deleteItem = item;
    modalRef.componentInstance.deletePopupEmit.subscribe((deleteItemId) => {
      if (deleteItemId != null) {
        var nrbes = new NrbesItem();
        nrbes.id = deleteItemId.id;
        nrbes.standardId = deleteItemId.standard.id;
        nrbes.isDeleted = true;
        this.loading = true;
        this.standardService
          .removeStandardFromNrbes(nrbes.id)
          .subscribe((data: any) => {
            this.isDeleted = false;
            this.loading = false;
            this.page = 1;
            this.getAllNrbesBySelectedCountryId();
          });
      }
      this.ngbModal.dismissAll();
    });
  }

  addAddendum(standardId: number, event): void {
    event.stopPropagation();
    this.router.navigate(["/add-addendum/" + standardId]);
  }

  goToAddendum(nrbesItem: any): void {
    console.log("nrbesItem", nrbesItem);
    try {
      this.storage.set("adCountryId", nrbesItem.country);
      this.router.navigate(["/addendum/" + nrbesItem.availabileAddendumId]);
    } catch (e) {
      console.log("ERROR WHILE NAVIGATING TO ADDENDUM", e);
    }
  }

  onEdit(id, event) {
    event.stopPropagation();
    this.standardService.standardEditPreviousRoute =
      this.activatedRoute.snapshot.routeConfig.path;
    this.router.navigate(["/add-eq-standards", id]);
  }

  closeMatMenuAndOpenDeleteModal(item, event) {
    this.trigger.closeMenu();
    setTimeout(() => {
      this.openDeletePopup(item, event);
    }, 100);
  }

  addSearchKey(searchKey) {
    this.searchKey = searchKey.value;
    this.page = 1;
    this.standardService.nationalEquipmentStandardFiltration.searchKey =
      this.searchKey;
    this.getAllNrbesBySelectedCountryId();
  }

  rowSelected(item: Standard): void {
    this.standardService.fromLocationGRS = false;

    this.router.navigate([
      "/view-national-equipments-standard-detail/" + item.id,
    ]);
  }

  downloadExcel() {
    this.isDownloading = true;
    this.standardService
      .downloadExcel(
        0,
        this.collectionSize,
        StandardListType.NationalEquipment,
        this.filterList,
        [this.selectedCountryId],
        null
      )
      .subscribe(
        (response: any) => {
          this.isDownloading = false;
          let filename =
            "National_EquipmentStandard_List " + new Date().toLocaleString();
          const blob = new Blob([response], {
            type: response.type,
          });
          if (
            (window.navigator as any) &&
            (window.navigator as any).msSaveOrOpenBlob
          ) {
            (window.navigator as any).msSaveOrOpenBlob(blob, filename);
            return;
          }
          var a = document.createElement("a");
          document.body.appendChild(a);

          let url = window.URL.createObjectURL(blob);

          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);

          //window.open(url);
        },
        (error: any) => {
          const modalRef = this.ngbModal.open(FailModuleComponent);
          modalRef.componentInstance.errorMessage = error.error
            ? error.error.Message
            : error.message;
        }
      );
  }
  getLocationNames(item): any {
    if (
      item.standard.standardLocation &&
      item.standard.standardLocation.length > 0
    ) {
      return item.standard.standardLocation
        .map((loc) => loc.locationType.name)
        .join(", ");
    } else {
      return item.standard.locationType.name;
    }
  }
}
